import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    path: '/',
    component: loadableWithRetry(() => import('./NotificationsPage')),
    exact: true,
  },
]

export default routes
